import { makeAutoObservable } from 'mobx';
import { NotificationStore } from './stores/notificationStore';
import { WorkspaceStore } from './stores/workspaceStore';
import { ProjectStore } from './stores/projectStore';
import { TaskStore } from './stores/taskStore';
import { AlertNotificationStore } from './stores/alertNotificationStore';
import { UserModel } from './models/user';
import { AppStore } from './stores/appStore';
import { ProjectTemplateStore } from './stores/projectTemplateStore';
import { ReportStore } from './stores/reportStore';
import { UserProfileDataInterface } from '../interfaces/AuthInterface';
import { ViewStore } from './stores/viewStore';
import { SettingStore } from './stores/SettingStore';
import { TimeTrackingStore } from './stores/timeTrackingStore';
import { RichTextStore } from './stores/richTextStore';
import { ChatMessageStore } from './stores/chatMessageStore';
import { InvoiceStore } from './stores/invoiceStore';
import { CustomerStore } from './stores/customerStore';
import { SnoozeStore } from './stores/snoozeStore';

export class RootStore {
  notificationStore: NotificationStore = new NotificationStore();
  snoozeStore: SnoozeStore = new SnoozeStore();
  workspaceStore: WorkspaceStore = new WorkspaceStore();
  projectStore: ProjectStore = new ProjectStore();
  projectTemplateStore: ProjectTemplateStore = new ProjectTemplateStore();
  taskStore: TaskStore = new TaskStore();
  alertNotificationStore: AlertNotificationStore = new AlertNotificationStore();
  appStore: AppStore = new AppStore();
  viewStore: ViewStore = new ViewStore();
  settingStore: SettingStore = new SettingStore();
  timeTrackingStore: TimeTrackingStore = new TimeTrackingStore();
  reportStore: ReportStore = new ReportStore();
  richTextStore: RichTextStore = new RichTextStore();
  chatMessageStore: ChatMessageStore = new ChatMessageStore();
  invoiceStore: InvoiceStore = new InvoiceStore();
  customerStore: CustomerStore = new CustomerStore();
  currentUser: UserModel | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentUser(currentUser: UserProfileDataInterface) {
    if (!this.currentUser)
      this.currentUser =
        this.workspaceStore.currentWorkspace?.users?.find((user) => user.id === currentUser.id) || null;
  }

  //clear all stores
  clearAllStores() {
    this.notificationStore.clearInboxData();
    this.projectStore.clearProjectData();
    this.taskStore.clearTaskData();
    this.projectTemplateStore.clearProjectTemplateData();
    this.reportStore.clearReportData();
    this.settingStore.clearSettingData();
    this.appStore.clearAppData();
    this.chatMessageStore.clearChatMessageData();
    this.timeTrackingStore.clearTimeTrackingData();
    this.invoiceStore.clearAllInvoiceData();
    this.customerStore.clearAllCustomerData();
  }
}

export const rootStore = new RootStore();
